import DataVScrollTable from './scroll-table';
export default DataVScrollTable;
